import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';
import { ListDataJson } from '@/typings';
import { taskListJson } from '@/views/system/task/server';
import { initDomain } from '@/apis/defence';

const baseUrl = initDomain[0];
const getHotJiangSortUrl = `${baseUrl}/app/v1/queryRjModuleSort`;
const { getTaskInfo } = httpApi.task;
const { getShowHotGame } = httpApi.home;

export interface banner_list {
  img_url?: string;
  id: number;
  type: number;
  feature: string[];
  main_title?: string;
  assistant_title?: string;
  link_url: string;
}

export interface labelListJson {
  gameId: number;
  id: number;
  labelId: number;
  labelName: string;
  rank: number;
}

export interface gamePopular {
  box_game_id: number;
  game_rank_logo_url: string;
  game_name: string;
  popular: number;
  game_popular: number;
  game_popular_new: number;
  game_version_name: string;
  game_tags: string;
  download_android: boolean;
  download_ios: boolean;
  download_pc: boolean;
  rencentPlayStr: string;
  awardName: string;
  live_no?: number;
  labelList: labelListJson[];
}

export interface gameListJson {
  banner_list: banner_list[];
  game_popular: gamePopular[];
  game_popular_new: gamePopular[];
  game_recommend: gamePopular[];
  grey_status: number;
  repair_tool_url?: string;
}

interface HomeIndexProps {
  type?: number | any;
}
// 首页banner
export function apiHomeIndex(data?: HomeIndexProps) {
  return request<gameListJson>({
    method: 'POST',
    url: httpApi.home.homeindex,
    data
  });
}

interface ignoreInterface {
  live_status: number; // 1 关闭
}
// 首页获取是否隐藏直播
export function apiGetIgnoreLiveByChannel() {
  return request<ignoreInterface>({
    method: 'POST',
    url: httpApi.home.ignoreLiveByChannel
  });
}

export interface game_infoProps {
  adIcon: number;
  boxGameId: number;
  downUrlAndroid: string;
  downUrlPc: string;
  gameDesc: string;
  gameId: number;
  gameName: string;
  gameTagId: number;
  gameVersionId: number;
  iosDownloadUrl: string;
  iosIcon: number;
  pcIcon: number;
  gameAppid: number;
}

export interface newGame {
  download_android: boolean;
  download_ios: boolean;
  download_pc: boolean;
  game_id: number;
  game_rank_logo_url: string;
  trait_name: string;
  type_name: string;
  status_attr: string;
  create_time: string;
  introduce: string;
  gameInfo: game_infoProps;
  live_no?: number;
  labelList: labelListJson[];
  gameGqs?: string;
}

export interface NewGameListJson {
  [key: string]: newGame[];
}

// 新游推荐
interface newGameListParams {
  clientTime?: number;
  type?: number | any;
  isStartGame?: boolean;
}
export function apiNewGameList(params?: newGameListParams) {
  return request<NewGameListJson>({
    method: 'GET',
    url: httpApi.home.NewGameList,
    params
  });
}

export interface openListSearchParams {
  section_id?: string | number;
  tag?: string | number;
  versionid?: string | number;
  show_icon?: string | number;
  labelIds?: string | number;
}

export interface taskProps {
  task_status?: number;
  task_draw_stime: number;
  bonus_state?: number;
  task_num?: string;
  bonus_info: string;
  surplus?: string;
  task_id: string;
}

export interface labelListProps {
  checked: number;
  labelId: number;
  labelName: string;
  rank: number;
}
export interface openListJson {
  rank_score: number;
  game_version_name?: string;
  game_name?: string;
  game_tags?: string;
  game_desc?: string;
  open_time?: string;
  section?: string;
  box_game_id?: number;
  task: taskProps;
  open_game_list_id?: number;
  download_android: boolean;
  download_ios: boolean;
  download_pc: boolean;
  game_id?: number;
  game_logo_url: string;
  section_id: number;
  game_appid: number;
  is_recommend: string;
  live_no?: number;
  rankIndex?: number;
  labelList: labelListProps[];
  specialLabelName: string;
  awardName: string;
  date?: string;
  position?: number;
}
// 开服列表
export function apiGetIndexOpenList(data?: openListSearchParams) {
  return request<ListDataJson<openListJson>>({
    method: 'POST',
    url: httpApi.home.get_index_open_list,
    data
  });
}

export interface openListSearchJavaParams {
  section_id?: string | number;
  tag?: string | number;
  versionid?: string | number;
  show_icon?: string | number;
  size?: number;
  page?: number;
  gameType?: number | any;
  now_time?: number | string;
  labelIds?: string;
  cursor?: string;
}

export interface openListJavaJson {
  game_info: ListDataJson<openListJson>;
  curQueryTimestamp: number | string;
}

// 开服列表 -- java
export function apiGetIndexOpenListJava(data?: openListSearchJavaParams) {
  return request<openListJavaJson>({
    method: 'POST',
    url: httpApi.home.get_index_open_list_java,
    data
  });
}

export interface timeSechionJson {
  section?: string;
  id?: number;
}
export interface timeProps {
  time_section: timeSechionJson[];
}
// 时间段配置获取
export function apiGetTimeSection() {
  return request<timeProps>({
    method: 'POST',
    url: httpApi.home.getTimeSection
  });
}

export interface tagListProps {
  rank?: number;
  tag_id?: number;
  checked?: number;
  tag_name?: string;
}

export interface versionListProps {
  id?: number;
  checked?: number;
  version_name?: string;
}

export interface versionTagList {
  tagList: tagListProps[];
  versionList: versionListProps[];
}
// 版本与标签接口
export function apiGetAllVersionAndTagList() {
  return request<versionTagList>({
    method: 'POST',
    url: httpApi.home.tagList
  });
}

export interface getRandomOpenListProps {
  box_game_id?: number;
  open_time: number;
  game_logo_url?: string;
  game_name?: string;
  game_version_name?: string;
  game_tags: string;
  server_name?: string;
}

export interface getRandomOpenList {
  random_open_list: getRandomOpenListProps[];
}

// 新服推荐
export function apiGetRandomOpenList() {
  return request<getRandomOpenList>({
    method: 'POST',
    url: httpApi.home.get_random_open_list
  });
}

export interface GetTaskInfoParams {
  taskid: string;
}
// 新服详情
export function apiGetTaskInfo(data: GetTaskInfoParams) {
  return request<taskListJson>({
    method: 'POST',
    url: getTaskInfo,
    data
  });
}
export interface GetAllRankGamesProps {
  gameType: number;
  clientTime?: number;
  type?: number | any;
}
export interface GetAllRankGamesJson {
  game_popular: gamePopular[];
  game_popular_new: gamePopular[];
  game_recommend: gamePopular[];
}

// 排行 -- java
export function apiGetAllRankGames(params: GetAllRankGamesProps) {
  return request<GetAllRankGamesJson>({
    method: 'GET',
    url: httpApi.home.allRankGames,
    params
  });
}

// pc展示控制热门游戏专栏是否展示
interface GetShowHotGameProps {
  isShow: number;
}
export function apiGetShowHotGame() {
  return request<GetShowHotGameProps>({
    method: 'GET',
    url: getShowHotGame
  });
}

// 精选推荐nav
interface GetHomeBannerSortParams {
  gameType: number;
}

export interface getHomeBannerSortJson {
  id: number;
  assortName: string;
}

export function getHomeBannerSort(params: GetHomeBannerSortParams) {
  return request<getHomeBannerSortJson[]>({
    method: 'GET',
    url: httpApi.home.getHomeBannerSort,
    params
  });
}

// 精选推荐
interface JXInfoData {
  id?: number;
  type?: number;
  gameType?: number;
  page: number;
  size: number;
}

export interface JXitemJson {
  faceImg: string;
  title: string;
  jumpType: number;
  jumpUrl: string;
  mark?: boolean;
  adId?: string;
  assortId?: number;
  collectJumpType?: number;
  jumpPosition?: string;
  roomType?: number;
  roomId?: number;
  object_id?: number;
  object_type?: string;
  live_platform?: string;
  extraParam?: string;
}

interface JXJson {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  data: JXitemJson[];
}

export function getJXList(params: JXInfoData) {
  return request<JXJson>({
    method: 'GET',
    url: httpApi.home.getBannerList,
    params
  });
}

// 开屏页广告
interface AdShowParams {
  adTypeId: number;
}

interface ResourceItem {
  resourceValue: string;
  showType: string;
}

export interface AdShowJson {
  adId: number;
  adImgUrl: string;
  targetId: number;
  type: number;
  subjectResourceList?: ResourceItem[];
}

export function adShow(params: AdShowParams) {
  return request<AdShowJson>({
    method: 'GET',
    url: httpApi.home.adShow,
    params
  });
}

// 热江板块排序
export interface RjModule {
  /**
   * 是否启用 true: 启用, false 不启用
   */
  enable?: boolean;
  /**
   * 模块类型 BANNER: banner以及轮播, NEW: 新游推荐, ACT: 活动,  OPEN: 开服列表,  GUIDE: 推荐攻略, RANK: 排行榜
   */
  type?: string;
}

interface GetHotJiangSortData {
  /** 模块列表 */
  modules: RjModule[];
}

export function getHotJiangSort() {
  return request<GetHotJiangSortData>({
    method: 'GET',
    url: getHotJiangSortUrl
  });
}
